export const DEFAULT_FORMAT_DATE_DAY_MONTH_YEAR_SLASH = 'DD/MM/yyyy';
export const DEFAULT_FORMAT_DATE_YEAR_MONTH_DAY_MINUS_API_REF = 'YYYY-MM-DD';
export const DEFAULT_FORMAT_READABLE_DATE_MONTH_YEAR = 'DD MMMM YYYY';
export const DEFAULT_FORMAT_READABLE_MONTH_YEAR = 'MMMM YYYY';
export const DEFAULT_FORMAT_READABLE_MONTH_INITIAL_WITH_YEAR = 'MMM YYYY';
export const DEFAULT_FORMAT_READABLE_MINIMUM_MONTH_DATE_COMMA_WITH_YEAR = 'MMM DD, YYYY';
export const DEFAULT_FORMAT_READABLE_YEAR_MONTH = 'YYYY MMMM';
export const DEFAULT_FORMAT_DATE_DAY_MONTH_YEAR_UNDERSCORE = 'DD_MM_yyyy';
